import { currentGtfsDate } from '@pysae/transit-core/service-day';
import type { TimetableDay } from './types';

/** Today plus the next 6 days — the window the GTFS calendars are loaded for. */
export const DAY_COUNT = 7;

/**
 * The selectable days, starting from the network service day rather than the
 * phone's, so that "today" is the same day as `appStore.todayDateGtfs`. Days
 * are stepped in UTC: calendar arithmetic that neither the browser timezone
 * nor a DST change can shift.
 */
export function timetableDays(
  now: Date,
  tz: string,
  label: (date: Date, offset: number) => string,
): Array<TimetableDay> {
  const today = currentGtfsDate(tz, now);
  const year = Number(today.slice(0, 4));
  const month = Number(today.slice(4, 6)) - 1;
  const day = Number(today.slice(6, 8));

  return Array.from({ length: DAY_COUNT }, (_, offset) => {
    const date = new Date(Date.UTC(year, month, day + offset));
    return { date, key: date.toISOString().slice(0, 10).replace(/-/g, ''), label: label(date, offset) };
  });
}

/** Localized short weekday and day number of a timetable day, e.g. "Mer. 5". */
export function weekdayLabel(date: Date, locale: string): string {
  // Intl abbreviates lowercase in fr/it ("mer.", "mer") and capitalized in en ("Wed")
  const weekday = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' }).format(date);
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${date.getUTCDate()}`;
}
